import moment from "moment";
import React, { Component } from "react";

class CustomDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      selectedOptions: this.props.betSlipField.selectedDrawsIds
        && this.props.betSlipField.selectedDrawsIds
 
    };
  }

  toggleDropdown = () => {
    this.setState((prevState) => ({
      isOpen: !prevState.isOpen,
    }));
  };

  handleOptionClick = (option) => {
    const { betSlipField, handleSelect } = this.props;
    const { selectedOptions } = this.state;
    console.log("selectedOptions1",selectedOptions);
    const index = selectedOptions.indexOf(option);
    let newSelectedOptions = [];

    if (index === -1) {
      newSelectedOptions = [...selectedOptions, option];
    } else {
      selectedOptions.splice(index, 1);
      newSelectedOptions = [...selectedOptions];
    }
    this.props.handleSelect([...newSelectedOptions], betSlipField);
    this.setState({
      selectedOptions: newSelectedOptions,
    });
  };

  handleOutsideClick = (event) => {
    if (this.dropdownRef && !this.dropdownRef.contains(event.target)) {
      this.setState({
        isOpen: false,
      });
    }
  };

  componentDidMount() {
    document.addEventListener("mousedown", this.handleOutsideClick);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleOutsideClick);
  }

  render() {
    const { isOpen, selectedOptions } = this.state;
    const { betSlipField, drawEvents} = this.props;


    return (
      <div
        className="custom-dropdown"
        ref={(node) => (this.dropdownRef = node)}
      >
        <div className="dropdown-header" onClick={this.toggleDropdown}>
          <div>
            {selectedOptions && selectedOptions.length > 0
              ? `${selectedOptions.length} - Draws `
              : `Select Draws`}
          </div>

          <div>
            <span className="arrow">{isOpen ? "▲" : "▼"}</span>
          </div>
        </div>
        {isOpen && (
          <div className="dropdown-options">
            {drawEvents.map((option,idx) => (
              <div
                style={idx==0 ? {cursor:"not-allowed"}:{}}
                key={option.eventId}
                className={
                  selectedOptions.includes(option.eventId)
                    ? "selected-dropdown-item dropdown-menu"
                    : "dropdown-menu"
                }
                onClick={() => idx !== 0 && this.handleOptionClick(option.eventId)}
              >
                <input
                  className="drop-down-checkbox"
                  type="checkbox"
                  readOnly
                  checked={selectedOptions.includes(option.eventId)}
                />
                <div>
                  {moment(option.eventDateOfMatch).format(
                    "DD MMM YYYY, HH:mm:ss"
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }
}

export default CustomDropdown;
